/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_Steps_TitleInputs */

const en_directory_guide_how_it_works_steps_title = /** @type {(inputs: Directory_Guide_How_It_Works_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three simple steps`)
};

const zh_directory_guide_how_it_works_steps_title = /** @type {(inputs: Directory_Guide_How_It_Works_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三个简单步骤`)
};

/**
* | output |
* | --- |
* | "Three simple steps" |
*
* @param {Directory_Guide_How_It_Works_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_steps_title = /** @type {((inputs?: Directory_Guide_How_It_Works_Steps_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_Steps_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_steps_title(inputs)
	return zh_directory_guide_how_it_works_steps_title(inputs)
});
export { directory_guide_how_it_works_steps_title as "directory.guide.how_it_works.steps_title" }